var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "952.5px",
    height: "952.5px",
    viewBox: "0 0 952.5 952.5",
    style: {
      enableBackground: "new 0 0 952.5 952.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.45,822.5c40.7,40.699,88.2,72.699,141,95.1c54.8,23.201,112.899,34.9,172.8,34.9s118-11.699,172.8-34.9 c52.9-22.4,100.3-54.299,141-95.1c40.7-40.699,72.7-88.199,95.101-141c23.199-54.801,34.899-112.9,34.899-172.801 c0-59.899-11.7-118-34.899-172.799c-22.4-52.9-54.301-100.3-95.101-141c-40.7-40.7-88.2-72.7-141-95.1c-7.5-3.2-15.1-6.1-22.8-8.9 v153.5c23.4,13.3,45.2,29.9,64.8,49.5c57.4,57.4,89,133.7,89,214.799c0,81.102-31.6,157.4-89,214.801 c-57.399,57.4-133.7,89-214.8,89s-157.4-31.6-214.8-89c-57.4-57.4-89-133.699-89-214.801c0-81.099,31.6-157.399,89-214.799 c19.6-19.6,41.399-36.2,64.8-49.5V90.9c-7.6,2.8-15.2,5.7-22.8,8.9c-52.9,22.4-100.3,54.3-141,95.1c-40.7,40.7-72.7,88.2-95.1,141 c-23.2,54.8-34.9,112.9-34.9,172.799c0,59.9,11.7,118,34.9,172.801C89.75,734.301,121.75,781.801,162.45,822.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.25,511.801c38.7,0,70-31.301,70-70V213V70.4V70c0-38.7-31.3-70-70-70s-70,31.3-70,70v0.4V213v228.9 C406.25,480.5,437.55,511.801,476.25,511.801z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOn);
export default __webpack_public_path__ + "static/media/on.9284eb0ba531be588df0c05b26f00c32.svg";
export { ForwardRef as ReactComponent };